import { cn } from '@/lib/utils';

/**
 * A chat message's or question's author as social-service assigned it
 * (JSS#1191). A name nobody vouched for (an anonymous viewer's, or one from
 * before server-assigned identity) carries an "unverified" marker, so it
 * cannot pass for a host's.
 */
export function AuthorName({
  name,
  verified,
  className,
}: {
  name: string;
  verified?: boolean;
  className?: string;
}) {
  return (
    <span className={className}>
      {name}
      {verified === false && (
        <span
          title="This name was not verified"
          aria-label="unverified name"
          className={cn(
            'ml-1 align-middle rounded border border-jeket-silver-muted/40 px-1 py-px',
            'text-[10px] font-normal not-italic uppercase tracking-wide text-jeket-silver-muted',
          )}
        >
          unverified
        </span>
      )}
    </span>
  );
}
